export default {
  sections: {
    setup_fee: {
      title: 'Installatiekosten',
      description: 'Installatiekosten vanaf {{amount}} – in plaats van 1.000+',
    },
  },
  labels: {
    month: 'Maand (NETTO)',
    one_time_fee: 'Eenmalige vergoeding',
    more_options: 'Meer opties',
    discount_badge: '-{{percentage}}%',
  },
  features: {
    app: 'Uw eigen app in de App Store & Google Play',
    push_notifications: 'Pushmeldingen voor aanbiedingen',
    loyalty: "Klantbehoud via loyaliteitsprogramma's",
    offline_orders: 'Offline bestellingen mogelijk',
    individual_design: 'Individueel app-ontwerp',
  },
  setup_fee_options: {
    150: 'Standaard installatie',
    75: 'Verminderd',
    0: 'Geen aanmaakkosten',
  },
  feedback: {
    contract_signed_already: {
      title: 'Contract is al ondertekend',
      description: 'Neem contact op met technische ondersteuning voor wijzigingen',
    },
  },
};
